import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JobPosting } from '@app/models/recruiting/job-posting.model';
import { SettingsIntegrationService } from '@app/modules/settings/services';
import { NotifyService } from '@app/services';

@Component({
    templateUrl: './job-posting-reports-show.template.html',
    styleUrls: ['./job-posting-reports-show.style.scss'],
})
export class JobPostingReportsShowView {
    jobPosting: JobPosting;

    isLoading = false;

    constructor(
        public route: ActivatedRoute,
        private integrationService: SettingsIntegrationService,
        private notify: NotifyService
    ) {
        this.jobPosting = this.route.snapshot.data.models.get('jobPosting');
    }

    async onPause(pause: boolean): Promise<void> {
        try {
            this.isLoading = true;
            this.jobPosting = await this.integrationService.pauseJobIntegration(this.jobPosting.id, pause);
            this.notify.success({
                key: 'applicant-tracker.applicants.jobPostingHasBeenActionSuccessfully',
                params: { action: pause ? 'paused' : 'unpaused' },
            });
        } catch (err) {
            this.notify.error(err);
        }

        this.isLoading = false;
    }
}
